import Web3 from "web3";
import { getPlatformChains } from "../utils/formatters";
import {
  BATCH_TRANSFER_ADDRESS_GOERLI,
  CHAIN_BY_NETWORK,
  ContractAddresses,
  networkProviders,
  STAKING_ADDRESS_GEORLI,
} from "./contract-constant";
import { initContract } from "./root/contractInit";

import { Erc721ABI } from "./abis/Erc721ABI";
import { Erc1155ABI } from "./abis/Erc1155ABI";
import { StakingABI } from "./abis/StakingABI";
import { BatchTransferABI } from "./abis/BatchTransferABI";
import axios, { all } from "axios";
import { SERVER_BASE_URL } from "../constants";

let stakingDatabaseContract;
let tokenContract;

let stakingContract;
let batchTransferContract;

let web3;

// type NetworkTypes = 2 | 3 | 4;

// console.log("stakingContract", stakingContract);

export const initializeContract = async (provider) => {
  web3 = new Web3(provider);

  stakingContract = new web3.eth.Contract(
    StakingABI.abi,
    STAKING_ADDRESS_GEORLI
  );

  batchTransferContract = new web3.eth.Contract(
    BatchTransferABI.abi,
    BATCH_TRANSFER_ADDRESS_GOERLI
  );

  // console.log("stakingContract => ", stakingContract);

  // console.log("web3", web3);
};

export const initializeContractStuff = async (
  platform,
  network,
  onContractInitialized
) => {
  try {
    web3 = new Web3(networkProviders[network]);

    console.log("initializing contract stuff : ", {
      platform,
      network,
      web3: networkProviders[network],
    });

    [stakingDatabaseContract, tokenContract] = await initContract(
      platform,
      network,
      web3
    );
    onContractInitialized({
      address: stakingDatabaseContract._address,
      name: platform,
      chain: CHAIN_BY_NETWORK[network],
      supportedChains: getPlatformChains(platform),
      network,
    });

    console.log("initializeContractStuff", {
      stakingDatabaseContract,
      tokenContract,
      balance: await tokenContract.methods
        .balanceOf(ContractAddresses[platform][network].distPool)
        .call(),
    });
  } catch (error) {
    console.log(error);
  }
};

export const getBalance = async (address) => {
  let bal;
  try {
    await web3.eth.getBalance(address).then((res) => {
      bal = web3.utils.fromWei(res, "ether");
    });
  } catch (err) {
    bal = false;
    console.log("error in getting balance", err);
  } finally {
    return bal;
  }
};

export const isEOAVerified = async (address) => {
  const isEoaVerified = await stakingContract.methods
    .checkEOAVerifed(address)
    .call();
  return isEoaVerified;
};

export const transferNft = async (
  from,
  to,
  address,
  tokenId,
  amount,
  callback
) => {
  try {
    console.log("mark1", { from, to, address, tokenId, amount });
    let nftContract = new web3.eth.Contract(
      Number(amount) > 0 ? Erc1155ABI.abi : Erc721ABI.abi,
      address
    );
    console.log("mark2 nftContract", nftContract);
    const safeTransferFrom =
      Number(amount) > 0
        ? nftContract.methods.safeTransferFrom(
            from,
            to,
            tokenId,
            amount,
            "0x00"
          )
        : nftContract.methods.safeTransferFrom(from, to, tokenId);

    console.log("mark3", safeTransferFrom);
    await safeTransferFrom
      .send({
        from: from,
      })
      .on("transactionHash", (hash) => {
        console.log("nft transfer transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("nft transfer", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            callback("Nft Sent Successfully", true);
          }
        }, 5000);
      });
  } catch (e) {
    console.log("err in transfer", e);
    callback("Something went wrong!", false);
  }
};

export const onConfirmYieldDistribution = (hash, index, length, callBack) => {
  try {
    var intervalVar = setInterval(async () => {
      let receipt = await web3.eth.getTransactionReceipt(hash);

      console.log("yield distribution", { receipt });

      if (receipt) {
        clearInterval(intervalVar);
        if (index === length - 1) {
          callBack();
          return true;
        }
      }
    }, 3000);
  } catch (e) {
    console.log("error after hash", e.message);
    return false;
  }
};

export const getContractName = async (address) => {
  let nftContract = new web3.eth.Contract(Erc721ABI, address);
  const name = await nftContract.methods.name().call();
  const token = await nftContract.methods.symbol().call();
  return { name, token };
};

export const getNftOwner = async (nft, userAddress) => {
  try {
    let nftContract;
    nftContract = new web3.eth.Contract(Erc721ABI, nft.nftAddress);

    console.log("nftContract", nftContract, nft.tokenId);
    const ownerAddress = await nftContract.methods.ownerOf(nft.tokenId).call();
    console.log(
      "ownerAddress",
      {
        ownerAddress,
        tokenId: nft.tokenId,
        userAddress,
        lenderId: nft?.lender?.id,
      },
      userAddress.toLowerCase() === ownerAddress.toLowerCase() ||
        STAKING_ADDRESS_GEORLI === ownerAddress ||
        nft?.lender?.id.toLowerCase() === userAddress.toLowerCase()
    );
    if (
      userAddress === ownerAddress ||
      STAKING_ADDRESS_GEORLI === ownerAddress ||
      nft?.lender?.id.toLowerCase() === userAddress.toLowerCase()
    ) {
      return ownerAddress;
    }
    // eslint-disable-next-line no-throw-literal
    throw `Nft is not in ownership of ${userAddress}`;
    // const token = await nftContract.methods.symbol().call();
  } catch (err) {
    console.log("err in getting owner", nft.tokenId, err);
    return false;
  }
};

export const fromWei = (value) => {
  return Web3.utils.fromWei(value.toString(), "ether");
};

export const getNFTImageByContract = async (nft) => {
  // console.log("getNFTImageByContract", nft);
  try {
    // console.log("mark1");
    let nftContract = new web3.eth.Contract(Erc721ABI, nft.nftAddress);
    // console.log("mark2");

    let imageURI = await nftContract.methods.tokenURI(nft.tokenId).call();
    let obj = {
      ...nft,
      imageURI,
      image: imageURI,
    };
    const isIpfsUrl = imageURI.includes("ipfs");
    const isImageUriHasImage =
      !imageURI.includes("ipfs") &&
      (imageURI.includes("jpg") ||
        imageURI.includes("png") ||
        imageURI.includes("jpeg") ||
        imageURI.includes("gif") ||
        imageURI.includes("svg"));

    // console.log("mark3 imageURI", imageURI, {
    //   isImageUriHasImage: !isImageUriHasImage && !isIpfsUrl,
    //   isIpfsUrl,
    // });

    if (isIpfsUrl) {
      console.log("mark4", { imageURI, tokenId: nft.tokenId });
      const requestOptions = {
        method: "GET",
        // mode: "no-cors",
        // redirect: "follow",
      };

      await fetch(
        imageURI.replace("ipfs://", "https://ipfs.io/ipfs/"),
        // @ts-ignore
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => JSON.parse(result))
        .then((result) => {
          // console.log(result);
          // console.log(
          //   "mark5",
          //   imageURI.replace("ipfs://", "https://ipfs.io/ipfs/"),
          //   result
          // );
          if (result.image_url) {
            obj = {
              ...nft,
              ...result,
              image: result.image_url.replace(
                "ipfs://",
                "https://ipfs.io/ipfs/"
              ),
            };
          } else if (result.image) {
            obj = {
              ...nft,
              ...result,
              image: result.image.replace("ipfs://", "https://ipfs.io/ipfs/"),
            };
          } else if (result.subgraphImage) {
            obj = {
              ...nft,
              ...result,
              image: result.subgraphImage,
            };
          }
          // console.log("final in fetch", nft.tokenId, obj);
          // return obj;
        })
        .catch((error) => console.log("error", error));
    } else if (!isImageUriHasImage && !isIpfsUrl) {
      console.log("mark6", { imageURI, tokenId: nft.tokenId });
      const requestOptions = {
        method: "GET",
        // mode: "no-cors",
        // redirect: "follow",
      };
      await fetch(
        imageURI,
        // @ts-ignore
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          console.log("mark6.5", result);
          return JSON.parse(result);
        })
        .then((result) => {
          // console.log(result);
          console.log("mark7", result);
          // check if image url starts wit ipfs://
          if (result.image_url) {
            obj = {
              ...nft,
              ...result,
              image: result.image_url.replace(
                "ipfs://",
                "https://ipfs.io/ipfs/"
              ),
            };
          } else if (result.image) {
            obj = {
              ...nft,
              ...result,
              image: result.image.replace("ipfs://", "https://ipfs.io/ipfs/"),
            };
          } else if (result.subgraphImage) {
            obj = {
              ...nft,
              ...result,
              image: result.subgraphImage,
            };
          }
          // console.log("final in fetching image", nft.tokenId, obj);
          // return obj;
        })
        .catch((error) => console.log("error in second fetch", error));
    }

    // if(imageURI)

    console.log("final", { obj, tokenId: nft.tokenId });
    return obj;
  } catch (error) {
    console.log("error in getting image", error);
    return false;
  }
};

export const unLendNft = async (lendingIds, userAddress, unLendCallBack) => {
  try {
    console.log("unlend starts", lendingIds);
    await stakingContract.methods
      .unLend(lendingIds)
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("unLendNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("unLendNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            unLendCallBack("Nft Claimed Successfully!", true);
          }
        }, 5000);
      });
  } catch (err) {
    console.log("err in unlend", err);
    unLendCallBack("Something went wrong", false);
  }
};

export const batchTransfer = async (
  nftAddresses,
  toAddresses,
  tokenIds,
  amounts,
  userAddress,
  unLendCallBack
) => {
  try {
    console.log("inside", {
      nftAddresses,
      toAddresses,
      tokenIds,
      amounts,
      userAddress,
    });
    await nftApprovalForAll(nftAddresses[0], userAddress, amounts[0], true);

    await batchTransferContract.methods
      .bulkTransfer(nftAddresses[0], toAddresses, tokenIds)
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("batchTransfer transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("batchTransfer", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            unLendCallBack("Nfts sent Successfully", true);
          }
        }, 5000);
      });
  } catch (err) {
    console.log("err in batchTransfer", err);
    unLendCallBack("Something went wrong", false);
  }
};

export const batchTransfer1155 = async (
  nftAddresses,
  toAddresses,
  tokenIds,
  amounts,
  userAddress,
  unLendCallBack
) => {
  try {
    console.log("inside", {
      nftAddresses,
      toAddresses,
      tokenIds,
      amounts,
      userAddress,
    });
    await nftApprovalForAll(nftAddresses[0], userAddress, amounts[0]);

    let nftContract = new web3.eth.Contract(Erc1155ABI.abi, nftAddresses[0]);

    await nftContract.methods
      .safeBatchTransferFrom(
        nftAddresses[0],
        toAddresses[0],
        tokenIds,
        amounts,
        "0x00"
      )
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("1155 batchTransfer transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("batchTransfer", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            unLendCallBack("Nfts sent Successfully", true);
          }
        }, 5000);
      });
  } catch (err) {
    console.log("err in batchTransfer", err);
    unLendCallBack("Something went wrong", false);
  }
};

export const forceClaim = async (
  lendingIds,
  userAddress,
  forceClaimCallBack
) => {
  try {
    console.log("forceClaim starts", lendingIds);
    await stakingContract.methods
      .claimBacKTokens(lendingIds)
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("forceClaim transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("forceClaim", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            forceClaimCallBack("Nft Claimed Successfully", true);
          }
        }, 5000);
      });
  } catch (err) {
    console.log("err in unlend", err);
    forceClaimCallBack("Something went wrong", false);
  }
};

export const getSigAndKey = async (EOAAddress) => {
  try {
    const url = `${SERVER_BASE_URL}/wallet/getEOA/${EOAAddress.toLowerCase()}`;
    const resp = await fetch(url, { method: "get" });
    console.log("resp", resp);
    const responseJSON = await resp.json();

    // .then((response) => {
    console.log("getSigAndKey resp", responseJSON);
    return responseJSON;
    // });
  } catch (e) {
    console.log("error in getSigAndKey", e);
    return false;
  }
};

const nftApproval = async (address, tokenId, userAddress, amount) => {
  let nftContract = new web3.eth.Contract(
    Number(amount) > 0 ? Erc1155ABI.abi : Erc721ABI.abi,
    address
  );
  console.log("nftContract", nftContract);
  return await nftContract.methods
    .approve(stakingContract._address, tokenId)
    .send({
      from: userAddress,
    })
    .on("transactionHash", (hash) => {
      console.log("approveNFT transactionHash", hash);
      var intervalVar = setInterval(async () => {
        let receipt = await web3.eth.getTransactionReceipt(hash);

        console.log("approveNFT", { receipt });

        if (receipt) {
          clearInterval(intervalVar);
        }
      }, 5000);
    });
};
const nftApprovalForAll = async (
  address,
  userAddress,
  amount,
  isBulkTransfer = false
) => {
  console.log(
    "Number(amount) > 0 ? Erc1155ABI.abi : Erc721ABI.abi,",
    Number(amount) > 0 ? "Erc1155ABI.abi" : "Erc721ABI.abi,"
  );
  let nftContract = new web3.eth.Contract(
    Number(amount) > 0 ? Erc1155ABI.abi : Erc721ABI.abi,
    address
  );
  console.log("nftContract", nftContract);
  const addressToSendApproval = isBulkTransfer
    ? batchTransferContract._address
    : stakingContract._address;
  return await nftContract.methods
    .setApprovalForAll(addressToSendApproval, true)
    .send({
      from: userAddress,
    })
    .on("transactionHash", (hash) => {
      console.log("approveForAll transactionHash", hash);
      var intervalVar = setInterval(async () => {
        let receipt = await web3.eth.getTransactionReceipt(hash);

        console.log("approveForAll", { receipt });

        if (receipt) {
          clearInterval(intervalVar);
        }
      }, 5000);
    });
};

export const lendNFT = async (lendingParams, userAddress, lendCallback) => {
  try {
    console.log("lending params", { lendingParams, userAddress });
    const approval = lendingParams.length > 1;

    if (approval || Number(lendingParams[0]?.lendAmount) > 0) {
      await nftApprovalForAll(
        lendingParams[0].nft,
        userAddress,
        lendingParams[0]?.lendAmount
      );
    } else {
      await nftApproval(
        lendingParams[0].nft,
        lendingParams[0].tokenId,
        userAddress,
        0
      );
    }

    await stakingContract.methods
      .lend([...lendingParams])
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("lendNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("lendNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            lendCallback("Lended Successfully!", true);
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    lendCallback("Something went wrong", false);
  }
};

export const verifyAndlendNFT = async (
  lendingParams,
  signature,
  encKey,
  userAddress,
  lendCallback
) => {
  try {
    console.log(
      "lending params",
      [...lendingParams],
      [...signature],
      [...encKey]
    );

    const approval = lendingParams.length > 1;

    if (approval) {
      await nftApprovalForAll(
        lendingParams[0].nft,
        userAddress,
        lendingParams[0]?.nft?.lendAmount
      );
    } else {
      await nftApproval(
        lendingParams[0].nft,
        lendingParams[0].tokenId,
        userAddress,
        lendingParams[0]?.nft?.lendAmount
      );
    }

    await stakingContract.methods
      .verifyAndLend([...lendingParams], [...signature], [...encKey])
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("lendNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("lendNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            lendCallback("Lended Successfully!", true);
          }
        }, 5000);
      });
  } catch (error) {
    console.log("verifyAndlendNFT", error);
    lendCallback("Something went wrong", false);
  }
};

export const borrowNFT = async (lendingIds, userAddress, borrowCallback) => {
  try {
    console.log("borrow nfts params", { lendingIds, userAddress });

    await stakingContract.methods
      .borrow(lendingIds)
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("BorrowNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("BorrowNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            borrowCallback("Claimed Successfully!", true);
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    borrowCallback("Something went wrong", false);
  }
};

export const bulkLendNFT = async (lendingParams, userAddress, lendCallback) => {
  try {
    // let { nft, tokenId } = lendingParams;
    console.log({ lendingParams, userAddress, stakingContract });

    await Promise.all(
      lendingParams.map(async (nftB) => {
        let { nft, tokenId } = nftB;
        let nftContract = new web3.eth.Contract(Erc721ABI, nft);

        console.log("nftContract", nftContract);

        await nftContract.methods
          .approve(stakingContract._address, tokenId)
          .send({
            from: userAddress,
          })
          .on("transactionHash", (hash) => {
            console.log("approveNFT transactionHash", { hash, tokenId });
            var intervalVar = setInterval(async () => {
              let receipt = await web3.eth.getTransactionReceipt(hash);

              console.log("approveNFT", { receipt, tokenId });

              if (receipt) {
                clearInterval(intervalVar);
              }
            }, 5000);
          });
      })
    );

    await stakingContract.methods
      .handleLend([...lendingParams])
      .send({ from: userAddress })
      .on("transactionHash", (hash) => {
        console.log("lendNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("lendNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            lendCallback("Lended Successfully!", true);
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    lendCallback("Something went wrong", false);
  }
};

export const buyNFT = async (buyParams, userAddress, lendCallback) => {
  try {
    // let { nft, tokenId } = lendingId;
    const { lendingId, sellPrice } = buyParams;
    console.log({
      buyParams,
      userAddress,
      stakingContract,
      after: web3.utils.toWei(sellPrice, "ether"),
    });

    // await Promise.all(
    //   lendingId.map(async (nftB) => {
    //     let { nft, tokenId } = nftB;
    //     let nftContract = new web3.eth.Contract(Erc721ABI, nft);

    //     console.log("nftContract", nftContract);

    //     await nftContract.methods
    //       .approve(stakingContract._address, tokenId)
    //       .send({
    //         from: userAddress,
    //       })
    //       .on("transactionHash", (hash) => {
    //         console.log("approveNFT transactionHash", { hash, tokenId });
    //         var intervalVar = setInterval(async () => {
    //           let receipt = await web3.eth.getTransactionReceipt(hash);

    //           console.log("approveNFT", { receipt, tokenId });

    //           if (receipt) {
    //             clearInterval(intervalVar);
    //           }
    //         }, 5000);
    //       });
    //   })
    // );

    await stakingContract.methods
      .buyNft(lendingId)
      .send({
        from: userAddress,
        value: web3.utils.toWei(sellPrice, "ether"),
      })
      .on("transactionHash", (hash) => {
        console.log("buyNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("buyNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            lendCallback("Purchased Successfully!", true);
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    lendCallback("Something went wrong", false);
  }
};

export const handleRentNFT = async (
  rentingParams,
  userAddress,
  onRentCallback
) => {
  try {
    let { charges, id, rentDuration } = rentingParams;

    console.log("rentingparams  UPFRONT", {
      rentingParams,
      userAddress,
      chargesAfter: web3.utils.toWei(charges, "ether"),
    });
    let dummySignature =
      "0x3897e597dcb52d1b6f6bcb3f50ef5dbdc0d9a2cd03999d4085345931100c0fb4451888047bc5957afc582846b6769636705afbc9d86e1e32eef723d6433e33f31b";

    await stakingContract.methods
      .handleRent(
        [[id, rentDuration.toString(), web3.utils.toWei(charges, "ether")]],
        [dummySignature]
      )
      .send({
        from: userAddress,
        value: web3.utils.toWei(charges, "ether"),
      })
      .on("transactionHash", (hash) => {
        console.log("rentNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("rentNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            onRentCallback("Nft Rented Successfully!", true);
            // onRentCallback();
            console.log("clear interval with callback!");
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    onRentCallback("Something went wrong", false);
  }
};

export const handleDirectRentNFT = async (
  rentingParams,
  userAddress,
  onRentCallback
) => {
  try {
    let { charges, id, rentDuration } = rentingParams;

    console.log("rentingparams  DIRECT", {
      rentingParams,
      userAddress,
    });
    let dummySignature =
      "0x3897e597dcb52d1b6f6bcb3f50ef5dbdc0d9a2cd03999d4085345931100c0fb4451888047bc5957afc582846b6769636705afbc9d86e1e32eef723d6433e33f31b";

    await stakingContract.methods
      .handleDirectRent([{ id, rentDuration, charges }], [dummySignature])
      .send({
        from: userAddress,
      })
      .on("transactionHash", (hash) => {
        console.log("rentNFT transactionHash", hash);
        var intervalVar = setInterval(async () => {
          let receipt = await web3.eth.getTransactionReceipt(hash);

          console.log("rentNFT", { receipt });

          if (receipt) {
            clearInterval(intervalVar);
            onRentCallback("Nft Rented Successfully!", true);
            // onRentCallback();
            console.log("clear interval with callback!");
          }
        }, 5000);
      });
  } catch (error) {
    console.log(error);
    onRentCallback("Something went wrong", false);
  }
};

// Key is returned as base64
export const fetchDecryptedMsg = async (address) => {
  let msg;
  // Key is returned as base64
  await window?.ethereum
    .request({
      method: "eth_decrypt",
      params: ["encryptedMessage", address],
    })
    .then((decryptedMessage) => {
      console.log("The decrypted message is:", decryptedMessage);
      msg = decryptedMessage;
    })
    .catch((error) =>
      console.log("error in getting decryptedMsg", error.message)
    );
  console.log("msg", msg);
  return msg;
};

export const hitProxy = async () => {
  try {
    // let proxyContract = new web3.eth.Contract(
    //   ProxyABI,
    //   "0xa34210521dCE7cA7b36af6C846D7Ce05d62c6fF9"
    // );
    // console.log("hitProxy", proxyContract);
    // proxyContract.methods
    //   .getNFT("0xEc0B81a2689dA3C89d91057adDd3a50ea07CDE0e", 1, 1)
    //   .send({ from: "0xEc0B81a2689dA3C89d91057adDd3a50ea07CDE0e" });

    let lendingId = 2;
    let hexString = lendingId.toString(16);

    for (let i = hexString.length; i < 64; i++) {
      hexString = "0".concat(hexString);
    }
    console.log("hexString", hexString);
    let gasPrices = await getCurrentGasPrices();
    let funcSignature = await web3.eth.abi.encodeFunctionSignature(
      "getNFT(address,uint256,uint256)"
    );
    let rawTX = {
      from: "0xEc0B81a2689dA3C89d91057adDd3a50ea07CDE0e",
      to: "0x123Ae0AA8Bb704c8351786372E546EC0BE0Ed34C",
      data:
        "0x40d097c3" +
        "Ec0B81a2689dA3C89d91057adDd3a50ea07CDE0e" +
        "2CE6fBCe2D940725AF795Bf843f3D08d38801471" +
        hexString,
      gas: 2200000,
      gasPrice: gasPrices.low * 1000000000,
    };
    let pr_key = "";
    console.log("rawTX", { rawTX, funcSignature });
    let signed = await web3.eth.accounts.signTransaction(rawTX, pr_key);
    console.log("signed", signed);
    await web3.eth
      .sendSignedTransaction(signed.rawTransaction)
      .on("error", (error) => {
        console.log(error);
      })
      .on("transactionHash", (hash) => {
        console.log("transactionHash", hash);
      });
  } catch (error) {
    console.log(error);
  }
};

const getCurrentGasPrices = async () => {
  let response = await axios.get(
    "https://ethgasstation.info/json/ethgasAPI.json"
  );
  let prices = {
    low: response.data.safeLow / 10,
    medium: response.data.average / 10,
    high: response.data.fast / 10,
  };

  console.log("\r\n");
  console.log(`Current ETH Gas Prices (in GWEI):`);
  console.log("\r\n");
  console.log(`Low: ${prices.low} (transaction completes in < 30 minutes)`);
  console.log(
    `Standard: ${prices.medium} (transaction completes in < 5 minutes)`
  );
  console.log(`Fast: ${prices.high} (transaction completes in < 2 minutes)`);
  console.log("\r\n");

  return prices;
};
